export enum RES_CHOICE {
  RES_TARIFGRUPPE = 'resTarifgruppe',
  RES_BERUFSSTATUS = 'resBerufsstatus',
  RES_VORSCHADENBEREICH = 'resVorschadenbereich',
}

export enum RES_META {
  RES_TARIFGRUPPE_IS_FAMILY = 'isFamilie',
}
